/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
import { languageFn } from 'app/common/components/customFunction';
import { refreshAuth } from 'app/requests';
import { configData } from 'app/utils/config';
import { isEqual } from 'app/utils/javascript';
import { getItem } from 'app/utils/session';
import axios from 'axios';

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
});

instance.interceptors.request.use(
    async (config) => {
        const authToken = getItem('token');
        const language = getItem("lang")
        config.headers.APP_NAME = configData.APP_NAME;
        config.headers.country = configData.country;
        config.headers['Accept-language'] = languageFn(language)
        if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
        } else if (!config?.headers?.['AUTH-TOKEN'] && authToken && config.data) {
            config.data.authToken = authToken;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

instance.interceptors.response.use(
    async (response) => {
        return response.data ? response : isEqual(response.data.error.errorCode, 32) && refreshAuth()
    },
    (error) => Promise.reject(error)
);

export default instance;
